export default __webpack_public_path__ + "96c4b09c2cc2dad289830bf36e1d48ae.png";